import { createContext, useState } from "react";

type PageContextType = {
  page: number;
  setPage: Function;
  maxPage: number;
  setMaxPage: Function;
};

export const PageContext = createContext<PageContextType>(undefined);

export const PageContextProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  // const pageRef = useRef(page);

  return (
    <PageContext.Provider value={{ page: page, setPage, maxPage, setMaxPage }}>
      {children}
    </PageContext.Provider>
  );
};
